
import request from '@/utils/request'

export function getListServiceTypeApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: {
      pCode: 'SERVICE_TP'
    }
  })
}

export function addServiceTypeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'post',
    data: query
  })
}

export function updateServiceTypeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'put',
    data: query
  })
}

export function deleteServiceTypeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'delete',
    data: query
  })
}
